
import React from "react";
import { RegulationItem } from "../RegulationItem";
import { Tent } from "lucide-react";

export const GeneralCamping = () => {
  return (
    <RegulationItem 
      value="general-camping" 
      icon={Tent}
      title="Daily General Camping"
    >
      <p className="text-tribal-neutral mb-4">
        Most campsites are non-electrical and require a Daily General Camping Permit. Fees are charged per camp vehicle, not per campsite. General campsites at Mountain View, Sheep Creek, and Lake Billy Shaw reservoirs are not numbered, allowing general camping in any suitable location around these reservoirs.
      </p>
    </RegulationItem>
  );
};
